import styled from 'styled-components';
import SelectSlideOriginal from '../../../SelectSlide/SelectSlide';
import ProductFullDetailsBodyOriginal from '../ProductFullDetailsBody/ProductFullDetailsBody';
import Icon from '../../../Icons/Icon';

export const SelectSlide = styled(SelectSlideOriginal)`
  margin-bottom: 24px;
`;

export const PanelItemIcon = styled(Icon)`
  width: 24px;
  font-size: 28px;
  margin-right: 8px;
`;

export const PanelLabel = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 16px;
`;

export const ProductFullDetailsBody = styled(ProductFullDetailsBodyOriginal)`
  padding: 16px 16px 0;
`;
